import { useRef } from "react";
import { PaywallOverlay } from "./PaywallOverlay";

export interface ToolFileActionsProps {
  locked?: boolean;
  featureTitle?: string;
  portalUrl?: string;
  onSave: () => void;
  onOpen: (file: File) => void;
  onNew?: () => void;
  saveLabel?: string;
  openLabel?: string;
  newLabel?: string;
}

export function ToolFileActions({
  locked = false,
  featureTitle = "opslaan en openen",
  portalUrl,
  onSave,
  onOpen,
  onNew,
  saveLabel = "Opslaan",
  openLabel = "Openen",
  newLabel = "Nieuw",
}: ToolFileActionsProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <PaywallOverlay locked={locked} featureTitle={featureTitle} portalUrl={portalUrl}>
      <div className="jari-tool-file-actions">
        <button type="button" className="jari-btn jari-btn--primary" onClick={onSave}>
          {saveLabel}
        </button>
        <button
          type="button"
          className="jari-btn"
          onClick={() => fileInputRef.current?.click()}
        >
          {openLabel}
        </button>
        {onNew && (
          <button type="button" className="jari-btn" onClick={onNew}>
            {newLabel}
          </button>
        )}
        <input
          ref={fileInputRef}
          type="file"
          accept=".jari,.json,application/json"
          hidden
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) onOpen(file);
            e.target.value = "";
          }}
        />
      </div>
    </PaywallOverlay>
  );
}
